import styled from "styled-components";

export const PageTitleWrapper = styled.span`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const DividerLine = styled.div`
  flex-grow: 1;
  background: #ffbc32;
  height: 3px;
`;
